export default __webpack_public_path__ + "static/media/bd1.8f0b9f5e.png";